// src/modules/restaurant/pages/orders/components/order-details/OrderSummary.tsx
import React from "react";
import { Order } from "src/shared/services/interfacev2";
import { useUser } from "src/shared/context/UserContext";

interface Props {
  selectedOrder: Order;
  themeTextColor: string;
  getLightBgClass: () => string;
}

const OrderSummary: React.FC<Props> = ({ selectedOrder, themeTextColor, getLightBgClass }) => {
  const { userConfigration } = useUser();
  const toBoolean = (value: any) =>value === true || value === "true";
  const deliveryFeeEnabled = toBoolean(userConfigration?.deliveryFeeEnabled);
  const parcelFeeEnabled = toBoolean(userConfigration?.parcelFeeEnabled);
  const tipsEnabled = toBoolean(userConfigration?.tipsEnabled);
  const txn = selectedOrder.orders?.[0];

  const subtotal = Number(txn?.orderAmount ?? 0);
  const discount = Number(txn?.discount ?? 0);
  const tip = Number(txn?.tip ?? 0);
  const finalAmount = Number(txn?.finalAmount ?? 0);
  const summaryItems = [
    { label: "Subtotal", value: subtotal.toFixed(2) || 0.0 },
    ...((parcelFeeEnabled && txn?.parcelFee !== undefined) ? [{ label: "Parcel Fee", value: Number(txn.parcelFee).toFixed(2) }] : []),
    { label: "Discount", value: discount.toFixed(2) || 0.0 },
    ...(deliveryFeeEnabled ? [{ label: "Delivery Fee", value: txn?.deliveryFee ? Number(txn.deliveryFee).toFixed(2) : "0.00" }] : []),
    ...(tipsEnabled ? [{ label: "Tip", value: txn?.tip ? Number(txn.tip).toFixed(2) : "0.00" }] : []),
  ];

  return (
    <div className={`bg-white rounded-xl border border-gray-200 p-2 mb-3`}>
      <h3 className={`text-lg font-semibold ${themeTextColor} mb-2 flex items-center gap-2`}>
        <i className="fas fa-receipt text-sm"></i> Order Summary
      </h3>

      {summaryItems.map((item, index) => (
        <div key={index} className="flex justify-between items-center py-1 ">
          <span className="font-medium text-sm">{item.label}</span>
          <span className={`font-semibold ${themeTextColor} text-sm`}>{item.value}</span>
        </div>
      ))}

      <div className="border-b border-gray-300 my-1.5"></div>

      <div className="flex justify-between items-center pt-1">
        <span className="text-lg font-bold">Total</span>
        <span className={`text-xl font-bold ${themeTextColor}`}>{finalAmount.toFixed(2)}</span>
      </div>
    </div>
  );
};

export default OrderSummary;
